module.exports = __webpack_public_path__ + "img/smooth-pk-chart-mobile.afdb4f16.png";